export * from "./DesktopIcon";
export { default } from "./DesktopIcon";
